<script>

export default {
    name: "EditButton"
}
</script>

<template>
    <div>
        <el-tooltip effect="dark" content="Редагувати" popper-class="custom-tooltip" placement="top-start">
            <div class="edit" @click="$emit('click')">
                <svg class="pen" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4506_5667)">
                        <path d="M14.1161 4.54126C14.4686 4.18888 14.6666 3.71091 14.6667 3.2125C14.6668 2.71409 14.4688 2.23607 14.1165 1.8836C13.7641 1.53112 13.2861 1.33307 12.7877 1.33301C12.2893 1.33295 11.8113 1.53088 11.4588 1.88326L2.56145 10.7826C2.40667 10.9369 2.29219 11.127 2.22812 11.3359L1.34745 14.2373C1.33022 14.2949 1.32892 14.3562 1.34369 14.4145C1.35845 14.4728 1.38873 14.5261 1.43132 14.5686C1.4739 14.6111 1.5272 14.6413 1.58556 14.656C1.64392 14.6707 1.70516 14.6693 1.76279 14.6519L4.66479 13.7719C4.87357 13.7084 5.06357 13.5947 5.21812 13.4406L14.1161 4.54126Z" stroke="#0A77FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 3.3335L12.6667 6.00016" stroke="#0A77FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4506_5667">
                            <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </el-tooltip>
    </div>
</template>

<style scoped lang="scss">
.edit {
    cursor: pointer;
    width: 40px;
    height: 40px;

    background: #FAFAFA;
    border-radius: 4px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    position: relative;

    .pen {
        width: 16px;
        height: 16px;

        position: absolute;
        left: calc(50% - 16px/2);
        top: calc(50% - 16px/2);
    }
}
</style>
<style>
.custom-tooltip {
    background: #D4D3D9 !important;
    color: black !important;
}
</style>
